import { useQuery } from "react-query";

import { getConfig } from "@jti/fe-common";
import type { GetContestsResponseType } from "@jti/rest-api-types";

import { LoyaltyApi } from "../../../services";

interface UseContestsBackendConfigParams {
  ciam_token: string | null;
  uuid: string | null;
  isInEditor?: boolean;
}

interface UseContestsBackendConfigReturn {
  contestsBackedConfig: GetContestsResponseType | null;
  isContestsBackendConfigLoading: boolean;
  isContestsBackendConfigError: Error | null;
}

const fetchContestsBackendConfig = async (ciam_token: string, uuid: string) => {
  if (!ciam_token || !uuid) {
    throw new Error("Missing ciam_token or uuid");
  }

  const apiInstance = LoyaltyApi.init();
  const result = await apiInstance.getContestStatus(uuid);

  return result;
};

export const useContestsBackendConfig = ({
  ciam_token,
  uuid,
  isInEditor = false,
}: UseContestsBackendConfigParams): UseContestsBackendConfigReturn => {
  const { isLoyaltyContestsServiceEnabled } = getConfig();
  const { data, isLoading, error } = useQuery(
    ["backendConfig", ciam_token, uuid],
    () => fetchContestsBackendConfig(ciam_token ?? "", uuid ?? ""),
    {
      enabled: Boolean(ciam_token && uuid && isLoyaltyContestsServiceEnabled && !isInEditor),
      retry: false,
    }
  );

  return {
    contestsBackedConfig: data || null,
    isContestsBackendConfigLoading: isLoading,
    isContestsBackendConfigError: error ? (error as Error & { error_message?: string }) : null,
  };
};
